import type { PurchasableNft } from "@/app/nft/buy/nfts-to-buy/scope"
import type { PriceValue } from "@anaconda/core/price/types"
import { useMolecule } from "bunshi/react"
import { useCallback } from "react"
import { SolanaBatchBuyTransactionMoleculeReatom } from "./solana-batch-buy-molecule.reatom"

export function useSolanaBatchBuy(
  nfts: PurchasableNft[],
  price: PriceValue | undefined,
) {
  const { batchBuyAction } = useMolecule(
    SolanaBatchBuyTransactionMoleculeReatom,
  )
  const isPending = batchBuyAction.pending() > 0

  const mutate = useCallback(() => {
    if (nfts.length === 0) return
    batchBuyAction({ nfts, price })
  }, [batchBuyAction, nfts, price])

  return { mutate, isPending }
}
